import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
`;

export const Video = styled.video`
  object-fit: cover;
  filter: brightness(1.2);
`;

export const Header = styled.div``;

export const Id = styled.div`
  font-size: 16px;
  color: #aaa;
`;

export const Title = styled.h1`
  padding: 0;
  margin: 0;
`;

export const By = styled.div`
  color: #aaa;
`;

export const Image = styled.img`
  width: 100%;
  filter: brightness(1.2) contrast(1.1);
  margin-top: -30px;
`;

export const Points = styled.div`
  font-size: 1px;
  position: absolute;
  right: -2px;
  bottom: 300px;
  display: none;
`;

export const Gap = styled.div`
  flex: 1;
`;
